import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import http from "./Api/http";
import { useTranslation } from "react-i18next";

const SSOLogin = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;

        const loginWithSSO = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get("code");
            if (!code) return;

            try {
                const res = await http.getJsonAxios(
                    http.actions.Auth.LoginWithSSO,
                    { code },
                    t
                );

                if (res.status === 200 && res.data.Success) {
                    localStorage.setItem("traffic_user", JSON.stringify(res.data.User));
                    localStorage.setItem("traffic_token", res.data.User.Token);

                    navigate("/SpareParts");
                } else {
                    toast.error(res.data?.message || "failed");
                }
            } catch (err) {
                toast.error("Network error");
            }
        };

        loginWithSSO();
    }, []);

    return <div>Logging in...</div>;
};

export default SSOLogin;